import { render, staticRenderFns } from "./StaticPageTemplate.vue?vue&type=template&id=617a5bdc&lang=pug&"
import script from "./StaticPageTemplate.vue?vue&type=script&lang=js&"
export * from "./StaticPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports